import store from "@/store";

export function getCommunityId(route) {
	let id = route.params.communityId;
	if (!id) id = store.state.session.communityId;
	return id;
}

export function getCommunity(route) {
	const communityById = store.getters["communities/itemById"];
	const id = getCommunityId(route);
	return communityById(id);
}
